export const challengeRoutes = {
  getChallenges: '/challenge',
  getAvailableChallenges: '/challenge/available',
  assignMaster: '/challenge/assign/master',
  assignSlave: '/challenge/assign/slave',
  unAssignMaster: '/challenge/unassign/master',
  unAssignSlave: '/challenge/unassign/slave',
} as const;
